var isObject = require('./_is-object');
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/node_modules/core-js/modules/_an-object.js
// module id = ../../../../core-js/modules/_an-object.js
// module chunks = polyfills vendor